export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl p-8 md:p-14 overflow-hidden relative">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50/10 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-background-50/10 blur-3xl"></div>
          </div>

          <div className="flex-1 relative z-10 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-background-50/20 text-background-50 rounded-full mb-5">
              📱 移动端专属体验
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
              漫漫漫画 APP
            </h2>
            <p className="text-sm md:text-base text-background-100 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              专为漫画阅读打造的下拉式流畅体验，支持离线缓存、深色模式、更新推送。
              在地铁上、被窝里、排队时——随时随地看漫画，畅享无广告纯净阅读。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-background-50 text-primary-600 rounded-full hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap border-0">
                <i className="ri-apple-line mr-1.5"></i>iOS 下载
              </button>
              <button className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-background-50/80 text-primary-600 rounded-full hover:bg-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap border-0">
                <i className="ri-android-line mr-1.5"></i>Android 下载
              </button>
            </div>
          </div>

          <div className="flex-shrink-0 relative z-10">
            <div className="w-48 md:w-56">
              <div className="bg-background-50 rounded-2xl p-3 shadow-sm">
                <div className="bg-background-200 rounded-xl aspect-[9/16] flex flex-col items-center justify-center p-4">
                  <i className="ri-book-open-line text-3xl text-primary-500 mb-3"></i>
                  <div className="w-full space-y-2">
                    <div className="h-2 bg-background-300 rounded-full w-3/4 mx-auto"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-full"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-full"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-5/6"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-full"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-4/5"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-full"></div>
                    <div className="h-1.5 bg-background-200 rounded-full w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}